"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieTokenProvider = void 0;
class CookieTokenProvider {
    constructor(cookieName) {
        this._cookieName = cookieName;
    }
    getToken() {
        return Promise.resolve(this.getCookie(this._cookieName));
    }
    getCookie(name) {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        if (match) {
            const cookieValuePosition = 2;
            return match[cookieValuePosition];
        }
        return null;
    }
}
exports.CookieTokenProvider = CookieTokenProvider;
